import ApplyBox from './src/main.js';
export default ApplyBox;
